import React from "react";

const ArtImageBox = ({
  index,
  src,
  nameValue,
  onNameChange,
  instructionsValue,
  onInstructionsChange,
}) => {
  return (
    <div
      key={index}
      style={{
        marginTop: "1rem",
        width: "auto",
        border: "2px solid #94C940",
        backgroundColor: "rgba(240, 240, 240, 1)",
        borderRadius: "8px",
        padding: "0.5rem",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <img
        src={src}
        alt={`preview-${index}`}
        style={{ width: "100px", height: "auto" }}
      />
      <div style={{ flex: 1, marginLeft: "1rem" }} />
      <div>
        <div style={{ width: "100%", textAlign: "left" }}>
          <span>Custom Name</span>
          <input
            id={`name-input-${index}`}
            type="text"
            placeholder="Enter custom name"
            value={nameValue}
            onChange={(e) => onNameChange(index, e.target.value)}
            required
            style={{
              width: "100%",
              paddingInlineStart: "0.25rem",
              paddingBlock: "0.25rem",
              boxSizing: "border-box",
              border: "1px solid #ccc",
              borderRadius: "6px",
              fontSize: "1rem",
              fontFamily: "Anek Latin",
              marginBottom: "0.5rem",
              outlineColor: "#94C940",
            }}
          />
        </div>
        <div style={{ width: "100%", textAlign: "left" }}>
          <span>Instructions</span>
          <textarea
            id={`instructions-input-${index}`}
            placeholder="Enter instructions"
            value={instructionsValue}
            rows={2}
            onChange={(e) => onInstructionsChange(index, e.target.value)}
            required
            style={{
              width: "100%",
              paddingInlineStart: "0.25rem",
              paddingBlock: "0.25rem",
              boxSizing: "border-box",
              border: "1px solid #ccc",
              borderRadius: "6px",
              fontSize: "1rem",
              fontFamily: "Anek Latin",
              outlineColor: "#94C940",
              textAlign: "left",
              resize: "none",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ArtImageBox;
